import styled from "styled-components";

import { SatisfactionSurveyButtonContent } from "../SatisfactionSurveyModal/styles";

export const SatisfactionSurveyResultContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 1440px) {
    margin-top: 1rem;
  }
  .required {
    color: #ec3434;
  }

  ${SatisfactionSurveyButtonContent} {
    display: grid;
    grid-template-columns: repeat(5, auto);
    gap: 0.5rem;

    &.stars {
      direction: rtl;

      .star {
        border: none;
        filter: grayscale(100%);
      }

      .star:not(.selected, .selected ~ .star) {
        opacity: 0.5;
      }

      .star:is(:hover:not(:disabled), :active, :focus, .selected),
      .star:is(:hover:not(:disabled), :active, :focus, .selected) ~ .star {
        cursor: pointer;
        filter: grayscale(0);
        opacity: 1;
      }

      .star:hover,
      .star:hover ~ .star {
        img {
          opacity: 1;
        }
      }
    }

    &.numeric {
      .number {
        font: 700 1rem/1.7rem "Inter";
        min-width: 2.625rem;
        min-height: 2rem;
      }

      .number:is(:hover:not(:disabled), :active, :focus, .selected) {
        cursor: pointer;
        background-color: #0073e51f;
        border: 1px solid #0073e5;
      }
    }

    &.emojis {
      gap: 0.5rem;

      .emoji {
        filter: grayscale(100%);
        border: none;
      }

      .emoji:is(:hover:not(:disabled), :active, :focus, .selected) {
        cursor: pointer;
        filter: grayscale(0);
        scale: 1.2;
      }

      .emoji:hover {
        img {
          opacity: 1;
        }
      }
    }
  }
`;

export const SatisfactionSurveyText = styled.p`
  all: unset;

  font: 500 0.875rem/1.313rem "Inter";
  color: ${({ theme }) => theme.groups.primaryText} !important;
`;

export const SatisfactionSurveyEmoji = styled.div`
  font-size: 1.5rem;
  filter: grayscale(100%);

  transition: all 0.2s;

  &.selected {
    filter: grayscale(0);
    scale: 1.1;
  }

  :is(:hover, :active, :focus) {
    transform: translateY(-5px);
    filter: grayscale(0);
    scale: 1.1;
    cursor: pointer;
  }
`;

export const SatisfactionSurveyResultContent = styled.div``;
